





















import { Component, Vue, Watch } from 'vue-property-decorator';
import PageHeader from '@/components/PageHeader.vue';
import PageFooter from '@/components/PageFooter.vue';
import LoginPopup from '@/components/auth/LoginPopup.vue';
import { authModule, snackModule } from '@/store';
import { ApiError, Wordpress } from '@/api';
import { Route } from 'vue-router';

@Component({
  components: {
    PageHeader,
    PageFooter,
    LoginPopup,
  },
})
export default class extends Vue {
  acfOptions: any = null;

  menuOpen: boolean = false;
  showHeaderFooter: boolean = true;

  get ready(): boolean {
    return authModule.ready;
  }

  get isLoggedIn(): boolean {
    return authModule.isLoggedIn;
  }

  get nextQuery(): string {
    return typeof this.$route.query.next === 'string'
      ? this.$route.query.next
      : '';
  }

  get snacks(): string[] {
    return snackModule.snacks;
  }

  get showSnackbar(): boolean {
    return snackModule.snacksVisible;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  async mounted() {
    try {
      const optionsData = await Wordpress.getOptionsData();
      this.acfOptions = optionsData.acf;
    } catch (err) {
      // Error
    }
    // console.log(process.env);
  }

  @Watch('$route', { immediate: true })
  titleChange(to: Route, from: Route) {
    if (
      (!from || from.name !== to.name) &&
      to.name !== 'auction' &&
      to.name !== 'dynamic-component'
    ) {
      if (to.meta.title) {
        document.title = to.meta.title + ' - Hobart Airport Parking';

        authModule.trackPageview({
          gtag: this.$gtag,
          route: to,
          pageTitle: to.meta.title,
        });
      } else {
        document.title = 'Hobart Airport Parking';
      }
    }
  }

  @Watch('$route.path')
  routeChanged() {
    this.menuOpen = false;
    this.showHeaderFooter = this.$route.matched[0].name !== 'admin';
  }
  @Watch('isLoggedIn')
  @Watch('nextQuery')
  isLoggedInChange() {
    // redirect once logged in if next query param is set
    if (this.isLoggedIn && this.nextQuery) {
      this.$router.replace(this.nextQuery);
    }
  }
}
